import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { LivePackageFilterEntity } from '../../domain/entities/LivePackageFilterEntity'
import type { PackageStatus } from '@/features/package/domain/enums/PackageStatus'

export class LivePackageFilterModel extends LivePackageFilterEntity {
  regionIds!: Array<number>
  declare packageStatuses: Array<PackageStatus>
  constructor(dataDto: LivePackageFilterEntity) {
    super()
    mapEntityProperties<LivePackageFilterModel>(this, dataDto, {
      exclude: ['regions'],
      map: {
        regionIds: dataDto.regions?.map((region) => region.id)
      }
    })
  }
}
